// removed by extract-text-webpack-plugin
module.exports = {"container":"_31bwGlqnCUnKqbxM1ko9KX","inner":"_2f3ONTb2DrUBBpRbEbd7us","as-seen-on":"_1Z_s0qZuJz9naEzPpDDvGQ","row-as-seen-on":"_2U2JCiEEEf6YAY4u6d5xI-","as-seen-on-container":"_1GJYvJUng9BorEmzxs9EB3","half-as-seen-on":"_1loztpyNwRxWhvneoE4Fzw","as-seen-link":"k5hSL8MUxKqPLW_gZjYSW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/AsSeenOn.scss
// module id = 1196
// module chunks = 47